import { type TagItem } from '@koala/sdk';

const tagsActions = {
  SET_ACTIVE_TAG: '/koala/tags/SET_ACTIVE_TAG',
  TOGGLE_ACTIVE_TAG: '/koala/tags/TOGGLE_ACTIVE_TAG',
  CLEAR_ACTIVE_TAGS: '/koala/tags/CLEAR_ACTIVE_TAGS',

  setActiveTag: (tag: TagItem) => ({
    type: tagsActions.SET_ACTIVE_TAG,
    id: tag.id,
    label: tag.label,
  }),

  /** Adds the tag to the selection, or removes it if it is already selected. */
  toggleActiveTag: (id: number) => ({
    type: tagsActions.TOGGLE_ACTIVE_TAG,
    id,
  }),

  clearActiveTags: () => ({
    type: tagsActions.CLEAR_ACTIVE_TAGS,
  }),
};

export default tagsActions;
